module.exports = __webpack_public_path__ + "img/海棠春好_四方連續_線稿_black.c6deef2d.png";